import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Button} from 'views/components';
import {AddCircleOutline as AddCircleOutlineIcon} from 'views/icons';
import {Translate} from 'views/module';
import {TaskModal} from 'views/module';

import TaskView from './TaskView';

const TaskList = (props) => {
  const [model, setModel] = React.useState({});

  const caregiverRn = props.caregiverRn;
  const caregiverName = props.caregiverData?.caregiverName || '';
  const caregiverTasks = props.caregiverTasks;
  const caregiverBackend = props.caregiverBackend;

  const openDialogs = {
    close: () => {
      setModel({});
    },
    addTask: () => {
      setModel({action: 'ADD_TASK'});
    },
    editTask: (task) => {
      setModel({action: 'EDIT_TASK', task});
    },
  };

  const edits = {
    addTask: (taskData) => {
      const complete = () => {
        setModel({});
      };
      caregiverBackend.tasks.addTask(taskData, complete);
    },
    editTask: (taskRn, taskData) => {
      const complete = () => {
        setModel({});
      };
      caregiverBackend.tasks.updateTask(taskRn, taskData, complete);
    },
    removeTask: (taskData) => {
      const complete = () => {
        setModel({});
      };
      caregiverBackend.tasks.removeTask(taskData.taskRn, complete);
    },
  };

  const popModelGenerator = React.useCallback(() => {
    let popModel = null;
    switch (model.action) {
      case 'ADD_TASK':
        popModel = (
          <TaskModal
            mode='add'
            onClose={openDialogs.close}
            addTask={edits.addTask}
            caregiverRn={caregiverRn}
            caregiverName={caregiverName}
          />
        );
        break;
      case 'EDIT_TASK':
        popModel = (
          <TaskModal
            mode='edit'
            onClose={openDialogs.close}
            editTask={edits.editTask}
            task={model.task}
            askStatus
          />
        );
        break;
    }
    return popModel;
  }, [model]);

  return (
    <Stack sx={{}}>
      {popModelGenerator()}
      {
        caregiverTasks.map((task, index) => (
          <TaskView
            key={task.taskRn || index}
            task={task}
            onClickEditTask={openDialogs.editTask}
            removeTask={edits.removeTask}
          />
        ))
      }
      <Button
        startIcon={<AddCircleOutlineIcon />}
        onClick={openDialogs.addTask}
        sx={{
          mx: 2,
          my: 1,
        }}
      >
        <Translate expression='client.ClientDetail.Tasks.TabLabels.CreateTask' />
      </Button>
    </Stack>
  );
};

TaskList.propTypes = {
  caregiverRn: PropTypes.string.isRequired,
  caregiverData: PropTypes.object,
  caregiverTasks: PropTypes.array.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
};

export default React.memo(TaskList);
